var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('comp-6-scenario',{attrs:{"page":9,"scenario":'scenario3'}})}
var staticRenderFns = []

export { render, staticRenderFns }